
//Función para manejar el arrastre de archivos multimedia dentro del PreviewFileSelected.
export const handleDropFile = (files, filesSelected, setFilesSelected, type, setOpenMessageFileSize) => {

  let N = files.length; //Definir la cantidad de archivos arrastrados a ser verificados.

  //Hacer un bucle para extraer el tipo de archivo a ser enviado, y además setear la lista de archivos multimedia.

  for (let i = 0; i < N; i++) {

    const selectedFile = files[i]; //Seleccionar cada archivo arrastrado individualmente.

    // Comprobar si dentro de la lista de archivos multimedia existe alguno que tenga el mismo nombre que algunos de 
    // los archivos arrastrados recientemente.
    const fileExists = filesSelected.some(file => file.name === selectedFile.name);

    if (fileExists) { //Si ya existe algún archivo en la lista con ese nombre.
      console.log("Ya existe un archivo con ese nombre:", selectedFile.name);
      // Se setea la lista de archivos seleccionados, con la lista existente, sin agregar elementos.
      setFilesSelected(filesSelected);
      return type; // Y se retorna el tipo de archivo al que corresponde.
    } else { //Si no existe algún elemento con ese nombre.
      console.log("No existe un archivo con ese nombre:", selectedFile);

      let fileType = ""; // Identificar el tipo de archivo según la extensión o el tipo MIME
      if (selectedFile.type.startsWith("image")) {
        fileType = "image";
      } else if (selectedFile.type.startsWith("audio")) {
        fileType = "audio";
      } else {
        fileType = "document";
      }

      if (selectedFile.size > 9999999) { // Si el tamaño del archivo es mayor a 10MB.
        // Se setea la lista de archivos seleccionados, con la lista existente, sin agregar elementos.
        setFilesSelected(filesSelected);
        setOpenMessageFileSize(true); //Mostrar el mensaje de que el tamaño del archivo es mayor al soportado
        return type; //Retornar null.
      }

      //EN CASO DE QUE YA SEA LA 2DA. (SEGUNDA) VEZ QUE SE ARRASTRA UN ARCHIVO.
      if (type) { //Si ya está definido el tipo de archivo que se encuentra dentro del previewFileSelected.
        //Si el tipo de archivo que se arrastró recientemente es igual al tipo de archivo que se encuentra en el PreviewFileSelected.
        if (type === fileType) {
          console.log("el archivo arrastrado coincide con el que se encuentra en la vista previa: ", type);
          let newFilesSelectedArray = []; //Crear un array para incluir los nuevos archivos arrastrados, más los existentes.
          newFilesSelectedArray = [...filesSelected]; //Igualar a los archivos existentes.
          newFilesSelectedArray.push(selectedFile); //Se añade el nuevo archivo a la lista.
          // Se setea la lista de archivos seleccionados, incluyendo el archivo arrastrado anteriormente.
          setFilesSelected(newFilesSelectedArray);
          if (i === N - 1) { //Si ya se recorrieron y verificaron todos los archivos arrastrados.
            return fileType; // Retornar el tipo de archivo que se va a enviar.
          }
        }
        //Si el tipo de archivo que se arrastró recientemente no es igual al tipo de archivo que se encuentra en el PreviewFileSelected.
        else {
          // Se setea la lista de archivos seleccionados, con la lista existente, sin agregar elementos.
          setFilesSelected(filesSelected);
          return type; // Y se retorna el tipo de archivo que debe ser.
        }
      }

      //EN CASO DE QUE YA SEA LA 1RA. (PRIMERA) VEZ QUE SE ARRASTRA UN ARCHIVO.
      // Se setea la lista de archivos seleccionados, incluyendo los archivos arrastrados anteriormente.
      setFilesSelected(prevFiles => [...prevFiles, selectedFile]);
      console.log(`Tipo de archivo: ${fileType}`);
      if (i === N - 1) { //Si ya se recorrieron y verificaron todos los archivos arrastrados.
        return fileType; // Retornar el tipo de archivo que tienen que ser todos.
      }

    }
  }

  // Si no se encontraron archivos no existentes, puedes retornar null o undefined
  return null; // O puedes retornar undefined si prefieres
};